module.exports = __webpack_public_path__ + "img/lock_white.bc12a51a.svg";